import axios from 'axios';
import Cookies from 'js-cookie';

export default async function submitForm({ formId, portalId = '20379208', fields = [] }) {
  const hutk = Cookies.get('hubspotutk');
  const pageUri = window.location.href;
  const pageName = document.title;
  const postUrl = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`;

  fields = [...Object.keys(fields)].map((key) => {
    return {
      name: key,
      value: fields[key],
    };
  });

  const data = {
    // submittedAt: Date.now(),
    fields,
    context: {
      hutk,
      pageUri,
      pageName,
    },
  };
  try {
    const response = await axios({
      url: postUrl,
      method: 'POST',
      data: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response;
  } catch (error) {
    return error.response;
  }
}
